<!--
Copyright (C) 2024 Checkmk GmbH - License: GNU General Public License v2
This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
conditions defined in the file COPYING, which is part of this source code package.
-->

<template>
  <svg
    width="100%"
    height="100%"
    version="1.1"
    viewBox="0 0 50 31.22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m0 0h50l-25 31.22z" fill="currentColor" />
  </svg>
</template>
